import { c as _c } from "react-compiler-runtime";
import { createContext, useEffect, useContext, useMemo } from 'react';
import { MEASURE_MARK_NAMES } from '../../utils/performanceTracking';
import { useFetchCurrentView } from 'framework-listing-lib/internal/ViewTabs/hooks/useFetchViews';
import usePerformanceTracking from '../../hooks/usePerformanceTracking';
import { jsx as _jsx } from "react/jsx-runtime";
const CurrentViewContext = /*#__PURE__*/createContext(null);
export default function CurrentViewProvider(t0) {
  "use memo";

  const $ = _c(10);
  const {
    children
  } = t0;
  const viewsPerformanceTracking = usePerformanceTracking(MEASURE_MARK_NAMES.VIEWS);
  const {
    currentView,
    loading
  } = useFetchCurrentView();
  let t1;
  let t2;
  if ($[0] !== loading || $[1] !== viewsPerformanceTracking) {
    t1 = () => {
      if (loading) {
        return;
      }
      viewsPerformanceTracking.markTimeEnd();
    };
    t2 = [loading, viewsPerformanceTracking];
    $[0] = loading;
    $[1] = viewsPerformanceTracking;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== currentView || $[5] !== loading) {
    t3 = {
      currentView,
      loading
    };
    $[4] = currentView;
    $[5] = loading;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const value = t3;
  let t4;
  if ($[7] !== children || $[8] !== value) {
    t4 = /*#__PURE__*/_jsx(CurrentViewContext.Provider, {
      value: value,
      children: children
    });
    $[7] = children;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export function useCurrentViewContext() {
  "use memo";

  const context = useContext(CurrentViewContext);
  if (!context) {
    throw new Error("useCurrentView must be used within a CurrentViewProvider");
  }
  return context;
}